import React from 'react';
import type { Table } from '../../types';

interface QrCodeModalProps {
  table: Table;
  onClose: () => void;
  onSimulateScan: () => void;
}

const QrCodeModal: React.FC<QrCodeModalProps> = ({ table, onClose, onSimulateScan }) => {
  // In a real app, this URL would point to your production customer-facing page.
  const customerUrl = `${window.location.origin}${window.location.pathname}?view=customer&tableId=${table.id}`;
  // Using an external API to generate the QR code image
  const qrCodeImageUrl = `https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(customerUrl)}`;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-sm text-center relative">
        <button onClick={onClose} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-2xl">&times;</button>
        <h2 className="text-2xl font-bold text-gray-800 mb-4">QR Code for {table.name}</h2>
        <p className="text-gray-600 mb-6">Customers can scan this code to order from their table.</p>
        <div className="flex justify-center mb-6">
            <img src={qrCodeImageUrl} alt={`QR Code for ${table.name}`} className="w-64 h-64 border-4 border-gray-200 rounded-lg"/>
        </div>
        <p className="text-xs text-gray-500 mb-4 break-all">URL: {customerUrl}</p>
        <button
            onClick={onSimulateScan}
            className="w-full px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 font-semibold"
        >
            Simulate Scan
        </button>
      </div>
    </div>
  );
};

export default QrCodeModal;
